import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { MessageCircle, HelpCircle } from "lucide-react";

interface LPFaqSectionProps {
  language?: 'te' | 'en' | 'hi' | 'ur';
  projectName?: string;
  isLandingPage?: boolean;
}

const generalFaqData = {
  te: [
    {
      question: "GPR Infra ప్రాజెక్ట్‌లు HMDA/DTCP ఆమోదం పొందాయా?",
      answer: "అవును, GPR Infra ప్రాజెక్ట్‌లు DTCP Layout ఆమోదం, HMDA ఆమోదం మరియు RERA రిజిస్ట్రేషన్ పొందాయి. మేము పూర్తి క్లియర్ టైటిల్ తో లీగల్ డాక్యుమెంట్స్ అందిస్తాము."
    },
    {
      question: "కనీస బుకింగ్ అమౌంట్ ఎంత?",
      answer: "కనీస బుకింగ్ అమౌంట్ ₹50,000 మాత్రమే. మిగతా మొత్తాన్ని 48 నెలల వరకు 0% వడ్డీతో Flexi EMI లో చెల్లించవచ్చు."
    },
    {
      question: "EMI సదుపాయం అందుబాటులో ఉందా?",
      answer: "అవును! మేము Flexi EMI ఆఫర్ చేస్తున్నాము - మీకు వీలైనప్పుడు, వీలైనంత కట్టుకోండి. 48 నెలల వరకు 0% వడ్డీ!"
    },
    {
      question: "సైట్ విజిట్ ఎప్పుడు చేయవచ్చు?",
      answer: "ప్రతి రోజు ఉదయం 9 గంటల నుండి సాయంత్రం 6 గంటల వరకు సైట్ విజిట్ అందుబాటులో ఉంటుంది. ఉచిత పికప్ & డ్రాప్ సదుపాయం కూడా ఉంది."
    },
    {
      question: "ప్లాట్ పై అద్దె ఆదాయం ఎలా వస్తుంది?",
      answer: "మేము మీ ప్లాట్ పై Burma Teak ప్లాంటేషన్ చేస్తాము. ప్రతి సంవత్సరం ₹10,000 అద్దె + 10 సంవత్సరాలలో ₹10 లక్షల టీక్ ఆదాయం గ్యారంటీ!"
    },
    {
      question: "GPR Infra ప్రాజెక్ట్‌లు ఎక్కడ ఉన్నాయి?",
      answer: "GPR Infra ప్రాజెక్ట్‌లు Regional Ring Road (RRR), యాదాద్రి, పంతంగి, సాగర్ హైవే, మరియు శ్రీశైలం హైవే సమీపంలో ఉన్నాయి."
    }
  ],
  en: [
    {
      question: "Are GPR Infra projects HMDA/DTCP approved?",
      answer: "Yes, GPR Infra projects are DTCP Layout approved, HMDA approved, and RERA registered. We provide complete legal documents with clear title."
    },
    {
      question: "What is the minimum booking amount?",
      answer: "Minimum booking amount is just ₹50,000. Remaining amount can be paid via Flexi EMI up to 48 months at 0% interest."
    },
    {
      question: "Is EMI facility available?",
      answer: "Yes! We offer Flexi EMI - pay as per your convenience. 0% interest up to 48 months!"
    },
    {
      question: "When can I visit the site?",
      answer: "Site visits are available every day from 9 AM to 6 PM. Free pickup & drop facility is also available."
    },
    {
      question: "How does rental income on plots work?",
      answer: "We plant Burma Teak on your plot. You get ₹10,000 rent every year + ₹10 Lakhs teak income in 10 years - guaranteed!"
    },
    {
      question: "Where are GPR Infra projects located?",
      answer: "GPR Infra projects are located near Regional Ring Road (RRR), Yadadri, Pantangi, Sagar Highway, and Srisailam Highway."
    }
  ],
  hi: [
    {
      question: "क्या GPR Infra प्रोजेक्ट्स HMDA/DTCP अप्रूव्ड हैं?",
      answer: "हां, GPR Infra प्रोजेक्ट्स DTCP Layout अप्रूव्ड, HMDA अप्रूव्ड और RERA रजिस्टर्ड हैं। हम क्लियर टाइटल के साथ पूर्ण कानूनी दस्तावेज प्रदान करते हैं।"
    },
    {
      question: "न्यूनतम बुकिंग राशि कितनी है?",
      answer: "न्यूनतम बुकिंग राशि सिर्फ ₹50,000 है। बाकी राशि 48 महीने तक 0% ब्याज पर Flexi EMI से भुगतान कर सकते हैं।"
    },
    {
      question: "क्या EMI सुविधा उपलब्ध है?",
      answer: "हां! हम Flexi EMI प्रदान करते हैं - अपनी सुविधा के अनुसार भुगतान करें। 48 महीने तक 0% ब्याज!"
    },
    {
      question: "साइट विजिट कब कर सकते हैं?",
      answer: "साइट विजिट हर दिन सुबह 9 बजे से शाम 6 बजे तक उपलब्ध है। मुफ्त पिकअप और ड्रॉप सुविधा भी उपलब्ध है।"
    },
    {
      question: "प्लॉट पर किराया आय कैसे मिलती है?",
      answer: "हम आपके प्लॉट पर Burma Teak लगाते हैं। हर साल ₹10,000 किराया + 10 साल में ₹10 लाख टीक आय - गारंटीड!"
    },
    {
      question: "GPR Infra प्रोजेक्ट्स कहां स्थित हैं?",
      answer: "GPR Infra प्रोजेक्ट्स Regional Ring Road (RRR), यादादी, पंतांगी, सागर हाईवे और श्रीशैलम हाईवे के पास स्थित हैं।"
    }
  ],
  ur: [
    {
      question: "کیا GPR Infra پراجیکٹس HMDA/DTCP منظور شدہ ہیں؟",
      answer: "جی ہاں، GPR Infra پراجیکٹس DTCP Layout منظور شدہ، HMDA منظور شدہ اور RERA رجسٹرڈ ہیں۔ ہم کلیئر ٹائٹل کے ساتھ مکمل قانونی دستاویزات فراہم کرتے ہیں۔"
    },
    {
      question: "کم از کم بکنگ رقم کتنی ہے؟",
      answer: "کم از کم بکنگ رقم صرف ₹50,000 ہے۔ باقی رقم 48 ماہ تک 0% سود پر Flexi EMI سے ادا کر سکتے ہیں۔"
    },
    {
      question: "کیا EMI سہولت دستیاب ہے؟",
      answer: "جی ہاں! ہم Flexi EMI پیش کرتے ہیں - اپنی سہولت کے مطابق ادائیگی کریں۔ 48 ماہ تک 0% سود!"
    },
    {
      question: "سائٹ وزٹ کب کر سکتے ہیں؟",
      answer: "سائٹ وزٹ ہر روز صبح 9 بجے سے شام 6 بجے تک دستیاب ہے۔ مفت پک اپ اور ڈراپ سہولت بھی دستیاب ہے۔"
    },
    {
      question: "پلاٹ پر کرایہ آمدنی کیسے ملتی ہے؟",
      answer: "ہم آپ کے پلاٹ پر Burma Teak لگاتے ہیں۔ ہر سال ₹10,000 کرایہ + 10 سال میں ₹10 لاکھ ٹیک آمدنی - گارنٹیڈ!"
    },
    {
      question: "GPR Infra پراجیکٹس کہاں واقع ہیں؟",
      answer: "GPR Infra پراجیکٹس Regional Ring Road (RRR)، یادادری، پنتانگی، ساگر ہائی وے اور سری شیلم ہائی وے کے قریب واقع ہیں۔"
    }
  ]
};

const exoticaFaqData = {
  te: [
    {
      question: "ఈ ప్రాజెక్ట్ HMDA/DTCP ఆమోదం పొందిందా?",
      answer: "అవును, GPR Exotica పూర్తిగా DTCP Layout ఆమోదం మరియు RERA రిజిస్ట్రేషన్ పొందింది. మేము పూర్తి క్లియర్ టైటిల్ తో లీగల్ డాక్యుమెంట్స్ అందిస్తాము."
    },
    {
      question: "కనీస బుకింగ్ అమౌంట్ ఎంత?",
      answer: "కనీస బుకింగ్ అమౌంట్ ₹50,000 మాత్రమే. మిగతా మొత్తాన్ని 48 నెలల వరకు 0% వడ్డీతో Flexi EMI లో చెల్లించవచ్చు."
    },
    {
      question: "EMI సదుపాయం అందుబాటులో ఉందా?",
      answer: "అవును! మేము Flexi EMI ఆఫర్ చేస్తున్నాము - మీకు వీలైనప్పుడు, వీలైనంత కట్టుకోండి. 48 నెలల వరకు 0% వడ్డీ!"
    },
    {
      question: "సైట్ విజిట్ ఎప్పుడు చేయవచ్చు?",
      answer: "ప్రతి రోజు ఉదయం 9 గంటల నుండి సాయంత్రం 6 గంటల వరకు సైట్ విజిట్ అందుబాటులో ఉంటుంది. ఉచిత పికప్ & డ్రాప్ సదుపాయం కూడా ఉంది."
    },
    {
      question: "ప్లాట్ పై అద్దె ఆదాయం ఎలా వస్తుంది?",
      answer: "మేము మీ ప్లాట్ పై Burma Teak ప్లాంటేషన్ చేస్తాము. ప్రతి సంవత్సరం ₹10,000 అద్దె + 10 సంవత్సరాలలో ₹10 లక్షల టీక్ ఆదాయం గ్యారంటీ!"
    },
    {
      question: "లొకేషన్ ఎక్కడ ఉంది?",
      answer: "GPR Exotica Regional Ring Road (RRR) Exit కి 5 KM మరియు యాదాద్రి-భద్రాద్రి హైవే కి 500 మీటర్ల దూరంలో ఉంది. హైదరాబాద్ నుండి 1 గంట డ్రైవ్."
    }
  ],
  en: [
    {
      question: "Is this project HMDA/DTCP approved?",
      answer: "Yes, GPR Exotica is fully DTCP Layout approved and RERA registered. We provide complete legal documents with clear title."
    },
    {
      question: "What is the minimum booking amount?",
      answer: "Minimum booking amount is just ₹50,000. Remaining amount can be paid via Flexi EMI up to 48 months at 0% interest."
    },
    {
      question: "Is EMI facility available?",
      answer: "Yes! We offer Flexi EMI - pay as per your convenience. 0% interest up to 48 months!"
    },
    {
      question: "When can I visit the site?",
      answer: "Site visits are available every day from 9 AM to 6 PM. Free pickup & drop facility is also available."
    },
    {
      question: "How does rental income on plots work?",
      answer: "We plant Burma Teak on your plot. You get ₹10,000 rent every year + ₹10 Lakhs teak income in 10 years - guaranteed!"
    },
    {
      question: "Where is the location?",
      answer: "GPR Exotica is 5 KM from Regional Ring Road (RRR) Exit and 500 meters from Yadadri-Bhadradri Highway. 1 hour drive from Hyderabad."
    }
  ],
  hi: [
    {
      question: "क्या यह प्रोजेक्ट HMDA/DTCP अप्रूव्ड है?",
      answer: "हां, GPR Exotica पूर्ण रूप से DTCP Layout अप्रूव्ड और RERA रजिस्टर्ड है। हम क्लियर टाइटल के साथ पूर्ण कानूनी दस्तावेज प्रदान करते हैं।"
    },
    {
      question: "न्यूनतम बुकिंग राशि कितनी है?",
      answer: "न्यूनतम बुकिंग राशि सिर्फ ₹50,000 है। बाकी राशि 48 महीने तक 0% ब्याज पर Flexi EMI से भुगतान कर सकते हैं।"
    },
    {
      question: "क्या EMI सुविधा उपलब्ध है?",
      answer: "हां! हम Flexi EMI प्रदान करते हैं - अपनी सुविधा के अनुसार भुगतान करें। 48 महीने तक 0% ब्याज!"
    },
    {
      question: "साइट विजिट कब कर सकते हैं?",
      answer: "साइट विजिट हर दिन सुबह 9 बजे से शाम 6 बजे तक उपलब्ध है। मुफ्त पिकअप और ड्रॉप सुविधा भी उपलब्ध है।"
    },
    {
      question: "प्लॉट पर किराया आय कैसे मिलती है?",
      answer: "हम आपके प्लॉट पर Burma Teak लगाते हैं। हर साल ₹10,000 किराया + 10 साल में ₹10 लाख टीक आय - गारंटीड!"
    },
    {
      question: "लोकेशन कहां है?",
      answer: "GPR Exotica Regional Ring Road (RRR) Exit से 5 KM और यादाद्री-भद्राद्री हाईवे से 500 मीटर दूर है। हैदराबाद से 1 घंटे की ड्राइव।"
    }
  ],
  ur: [
    {
      question: "کیا یہ پراجیکٹ HMDA/DTCP منظور شدہ ہے؟",
      answer: "جی ہاں، GPR Exotica مکمل طور پر DTCP Layout منظور شدہ اور RERA رجسٹرڈ ہے۔ ہم کلیئر ٹائٹل کے ساتھ مکمل قانونی دستاویزات فراہم کرتے ہیں۔"
    },
    {
      question: "کم از کم بکنگ رقم کتنی ہے؟",
      answer: "کم از کم بکنگ رقم صرف ₹50,000 ہے۔ باقی رقم 48 ماہ تک 0% سود پر Flexi EMI سے ادا کر سکتے ہیں۔"
    },
    {
      question: "کیا EMI سہولت دستیاب ہے؟",
      answer: "جی ہاں! ہم Flexi EMI پیش کرتے ہیں - اپنی سہولت کے مطابق ادائیگی کریں۔ 48 ماہ تک 0% سود!"
    },
    {
      question: "سائٹ وزٹ کب کر سکتے ہیں؟",
      answer: "سائٹ وزٹ ہر روز صبح 9 بجے سے شام 6 بجے تک دستیاب ہے۔ مفت پک اپ اور ڈراپ سہولت بھی دستیاب ہے۔"
    },
    {
      question: "پلاٹ پر کرایہ آمدنی کیسے ملتی ہے؟",
      answer: "ہم آپ کے پلاٹ پر Burma Teak لگاتے ہیں۔ ہر سال ₹10,000 کرایہ + 10 سال میں ₹10 لاکھ ٹیک آمدنی - گارنٹیڈ!"
    },
    {
      question: "لوکیشن کہاں ہے؟",
      answer: "GPR Exotica Regional Ring Road (RRR) Exit سے 5 KM اور یادادری-بھدرادری ہائی وے سے 500 میٹر دور ہے۔ حیدرآباد سے 1 گھنٹے کی ڈرائیو۔"
    }
  ]
};

const whatsappMessages = {
  te: "హాయ్, GPR Infra ప్లాట్ల గురించి మరిన్ని వివరాలు కావాలి.",
  en: "Hi, I need more details about GPR Infra plots.",
  hi: "हाय, GPR Infra प्लॉट के बारे में और जानकारी चाहिए।",
  ur: "ہیلو، GPR Infra پلاٹس کے بارے میں مزید تفصیلات چاہیے۔"
};

const LPFaqSection = ({ language = 'en', isLandingPage = false }: LPFaqSectionProps) => {
  const faqs = isLandingPage ? exoticaFaqData[language] : generalFaqData[language];
  const whatsappUrl = "https://wa.me/918297978080?text=" + encodeURIComponent(whatsappMessages[language]);

  return (
    <div className="bg-gradient-to-b from-slate-900 to-black py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 mb-4">
            <HelpCircle className="h-5 w-5 text-orange-400" />
            <span className="text-white font-medium">
              {language === 'te' ? 'తరచుగా అడిగే ప్రశ్నలు' : 
               language === 'hi' ? 'अक्सर पूछे जाने वाले प्रश्न' :
               language === 'ur' ? 'اکثر پوچھے جانے والے سوالات' :
               'Frequently Asked Questions'}
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-white">
            {language === 'te' ? 'మీ ప్రశ్నలకు సమాధానాలు' : 
             language === 'hi' ? 'आपके सवालों के जवाब' :
             language === 'ur' ? 'آپ کے سوالات کے جوابات' :
             'Your Questions Answered'}
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white/5 backdrop-blur border border-white/10 rounded-xl px-6 overflow-hidden"
            >
              <AccordionTrigger className="text-white text-left hover:no-underline py-4 text-base md:text-lg font-medium">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-300 pb-4">
                <p className="mb-4">{faq.answer}</p>
                <Button
                  variant="outline"
                  size="sm"
                  className="border-green-500 text-green-400 hover:bg-green-500/10 gap-2"
                  asChild
                >
                  <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                    <MessageCircle className="h-4 w-4" />
                    {language === 'te' ? 'WhatsApp లో అడగండి' : 
                     language === 'hi' ? 'WhatsApp पर पूछें' :
                     language === 'ur' ? 'WhatsApp پر پوچھیں' :
                     'Ask on WhatsApp'}
                  </a>
                </Button>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-8 text-center">
          <p className="text-gray-400 mb-4">
            {language === 'te' ? 'మరిన్ని ప్రశ్నలు ఉన్నాయా?' : 
             language === 'hi' ? 'और सवाल हैं?' :
             language === 'ur' ? 'مزید سوالات ہیں؟' :
             'Have more questions?'}
          </p>
          <Button
            className="bg-gradient-to-r from-[#25D366] to-[#128C7E] hover:from-[#22c55e] hover:to-[#15803d] text-white font-semibold px-8 h-12 rounded-xl gap-2"
            asChild
          >
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
              <MessageCircle className="h-5 w-5" />
              {language === 'te' ? 'WhatsApp లో చాట్ చేయండి' : 
               language === 'hi' ? 'WhatsApp पर चैट करें' :
               language === 'ur' ? 'WhatsApp پر چیٹ کریں' :
               'Chat on WhatsApp'}
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LPFaqSection;
